// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import { toast } from 'react-toastify';
import { withRouter } from 'react-router-dom';

import api from '../api';
import passwordStrength from '../utilities/passwordStrength';
import '../styles/start.css';

class Invite extends React.Component {

    state = {
        // Animation
        stage: 0,
        visible: false,

        // Submit variables
        name: "",
        password: "",

        userId: "",
        teamId: "",
        teamName: "",
        sso: false, // Is this team using single sing-on?
    }

    componentDidMount = async () => {
        const res = await api.get('/user/welcome?userId=' + this.props.match.params.userId, {}, true);

        if (!res || !res.userId || !res.team)
            return this.props.history.push('/');

        setTimeout(() => this.setState({
            stage: 1,
            visible: true,
            userId: res.userId,
            teamId: res.teamId,
            teamName: res.team,
            sso: res.sso
        }), 200);

        // return this.nextStage(null,8); // For testing only!
        // setTimeout(() => this.nextStage(null, 2), 3000);
        // setTimeout(() => this.nextStage(null, 3), 7000);
        setTimeout(() => this.nextStage(null, 4), 3000);
    }

    nextStage = (e, stage) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        this.setState({ visible: false });
        setTimeout(() => this.setState({
            stage: stage ? stage : this.state.stage+1,
            visible: true
        }),1500);
    }

    saveUserInfo = async (e) => {
        if(e){
            e.preventDefault();
            e.stopPropagation();
        }


        this.nextStage(null, 7);
        const res = await api.post('/user/setup', {
            userId: this.state.userId,
            userName: this.state.name,
            ...(this.state.sso? {}: {userPassword: this.state.password})
        });

        if (!res || !res.success)
            return this.nextStage(null, this.state.sso?4:6); // Return to try again

         // If successful, the API sets user cookies, we can go forward to login! :)

         // Not using sso? 
        if(!this.state.sso)
            setTimeout(async () => {
                await this.props.whoAmI();
                this.props.history.push('/');
            }, 1000);
        else(this.nextStage(null, 8));
    }

    renderHint = (check, available, taken) => {
        return (<div className="start-content-hint">
            {check.valid && !check.checking ? (check.available ? <>
                <img
                    src="https://static.stax.ai/images/icons/reviewed.png"
                    alt="Available"
                />{available}
            </> : <>
                <img
                    src="https://static.stax.ai/images/icons/alert.png"
                    alt="Unavailable"
                />{taken}
            </>) : ""}
        </div>);
    }

    render = () => {
        const pass = passwordStrength(this.state.password);

        return (<div className="start-container">
            <div className={"start-content" + (!this.state.visible ? " start-content-hidden" : "")}>

                {/* Hi */}
                {this.state.stage === 1 ? <>
                    <h1>Hi!</h1>
                </> :

                this.state.stage === 2 ? <>
                    {/* <h2>You've been invited to join <u><strong>{this.state.teamName}</strong></u> on Stax<div className="navigation-logo-dot" />ai!</h2> */}
                    <h2>Welcome to Stax<div className="navigation-logo-dot" />ai!</h2>
                </> :

                this.state.stage === 3 ? <>
                    <h1>Let's get you set up!</h1>
                    <div className="start-content-line" />
                    <h2>Your team is already on STAX<div className="navigation-logo-dot" />AI. We just need your name and a secure password to setup your account!</h2>
                </> :
                
                // User name
                this.state.stage === 4 ? <>
                    <h1>What's your name?</h1>
                    <form onSubmit={(e) => {
                        // Are we using SSO? If so, save the info and skip the password
                        if(this.state.sso){
                            this.nextStage(e); 
                            return setTimeout(() => this.saveUserInfo(), 4000); 
                        }
                        this.nextStage(e);
                        setTimeout(() => this.nextStage(), 4000);
                    }}>
                        <input
                            id="name"
                            name="name"
                            type="text"
                            placeholder="Enter name here..."
                            value={this.state.name}
                            onChange={e => this.setState({ name: e.target.value })}
                        />
                        {this.state.visible && this.state.name !== "" && <input
                            type="Submit"
                            title="Next"
                            value=""
                            readOnly={true}
                        />}
                    </form>
                </> :
                
                // Welcome
                this.state.stage === 5 ? <>
                    <h1>It's great to meet you, <span className="start-content-underline">{this.state.name.split(" ")[0]}</span>!</h1>
                </> :
                
                // Password
                this.state.stage === 6 ? <>
                    <h1>Create a login password</h1>
                    <form onSubmit={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (this.state.password === "")
                            return;
                        if (pass !== "ok")
                            return toast.error("Your password is not strong enough.");
                        this.saveUserInfo();
                    }}>
                        <input
                            id="password"
                            name="password"
                            type="password"
                            placeholder="Enter a secure password..."
                            value={this.state.password}
                            onChange={e => this.setState({ password: e.target.value })}
                        />
                        {this.state.visible && pass === "ok" && <input
                            type="submit"
                            value=""
                            title="Next"
                            readOnly={true}
                        />}
                    </form>
                    <div className="start-content-hint">
                        {this.state.password !== "" ? (pass === "ok" ? <>
                            <img
                                src="https://static.stax.ai/images/icons/reviewed.png"
                                alt="Available"
                            />Awesome, that's a strong password!
                        </> : <>
                            <img
                                src="https://static.stax.ai/images/icons/alert.png"
                                alt="Unavailable"
                            />{pass}
                        </>) : ""}
                    </div>
                </> :

                // Creating...
                this.state.stage === 7 ? <>
                    {/* Stax loading sign */}
                    <h1>Setting up your account...</h1>
                </> :
                
                // Account created!
                this.state.stage === 8 ? <>
                    <h1>That's it, you're all set!</h1>
                    <div className="start-content-line" />
                    <h2>You are now an official STAX<div className="navigation-logo-dot"></div>AI user!</h2>
                    <br/>
                    <br/>
                    <div>Click the button below to login</div>
                    {this.state.sso && <>
                        <div
                            className="button"
                            style={{
                                float: 'none',
                                backgroundImage: "url('https://static.stax.ai/images/icons/reviewed.png')"
                            }}
                            onClick={() => window.location.href = api.apiUrl + '/user/login/sso/' + this.state.teamId + '?redirect=true'}
                        >
                            Login
                        </div>
                    </>}
                
                </> : ""}

            </div>
        </div>);
    }

};

export default withRouter(Invite);